export const products = [
    {
      id: 'wkxKzQTG',
      name: 'Peashooter',
      image: "https://vignette.wikia.nocookie.net/vsbattles/images/e/e6/IMG_5964.png/revision/latest?cb=20171216115102",
      description: 'This plant is from Plants vs. Zombies and it is called Peashooter.',
      type: 1,
      price: 47,
      quantity: 10
    },
    {
      id: 'QCtNbxoV',
      name: 'Squash',
      image: "https://vignette.wikia.nocookie.net/plantsvszombies/images/4/42/Squash-hd.png/revision/latest?cb=20140326102023",
      description: 'This plant is from Plants vs. Zombies and it is called Squash.',
      type: 2,
      price: 6,
      quantity: 15
    },
    {
      id: 'HuYfzHBY',
      name: 'Snow Pea',
      image: "https://th.bing.com/th/id/R.544a45c235b57dc21ebd8ddfb8e5f854?rik=geQQ%2bR20mF9gmQ&riu=http%3a%2f%2fimages6.fanpop.com%2fimage%2fphotos%2f37400000%2fSnow-Pea-plants-vs-zombies-37448923-557-600.png&ehk=ut0tn3eF529s%2bKHeQxKEeqKeAPqoZES1opevCax3IY4%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Snow Pea.',
      type: 1,
      price: 10,
      quantity: 40
    },
    {
      id: 'MzSPJBLG',
      name: 'Grave Buster',
      image: "https://th.bing.com/th/id/OIP.ZvBo964SmOYzmJWXlTboYAAAAA?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Grave Buster.',
      type: 2,
      price: 22,
      quantity: 20
    },
    {
      id: 'tPmZaxkt',
      name: 'Scaredy-shroom',
      image: "https://i.pinimg.com/originals/20/93/ba/2093ba11c0942e0f9987c21c9eb87e64.png",
      description: 'This plant is from Plants vs. Zombies and it is called Scaredy-shroom.',
      type: 1,
      price: 14,
      quantity: 50
    },
    {
      id: 'AGJpwALR',
      name: 'Gloom-shroom',
      image: "https://th.bing.com/th/id/R.5229e9931ccf5e360f919286bd0d158f?rik=3u8ESFGDhCy8yA&riu=http%3a%2f%2fimg4.wikia.nocookie.net%2f__cb20120625031447%2fplantsvszombies%2fimages%2fb%2fb6%2fGloom-shroom21.png&ehk=zd3ONOb58gSSZiloij8dD5ucZL5UeSi10LPo39I28YI%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Scaredy-shroom.',
      type: 1,
      price: 67,
      quantity: 17
    },
    {
      id: 'SogpxRdv',
      name: 'Wall-nut',
      image: "https://th.bing.com/th/id/R.2db2a92dc7953cf578ec9738c1182190?rik=cSu1Bi6mlSsEig&riu=http%3a%2f%2fvignette1.wikia.nocookie.net%2fplantsvszombies%2fimages%2ff%2ff6%2fWalnut.png%2frevision%2flatest%3fcb%3d20140726232340&ehk=H%2bbBf1Tcg4QfuCMMUlWWDIE6gPVhAbIzrtbQNu%2fN4Go%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Wall-nut.',
      type: 2,
      price: 39,
      quantity: 40
    },
    {
      id: 'uePSmysw',
      name: 'Sunflower',
      image: "https://th.bing.com/th/id/OIP.jUEDJSb2WSqekCr0bHenSgHaHu?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Sunflower.',
      type: 1,
      price: 14,
      quantity: 9
    },
    {
      id: 'EmaaUiDj',
      name: 'Hypno-shroom',
      image: "https://th.bing.com/th/id/OIP.J28R2b2oHohyvqo0GPiy7QHaJc?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Hypno-shroom.',
      type: 1,
      price: 17,
      quantity: 5
    },
    {
      id: 'CCQOoHDN',
      name: 'Fume-shroom',
      image: "https://th.bing.com/th/id/R.12b7f1512a15a18fc75713728ea6d1bb?rik=efex4XAtFHiGzg&riu=http%3a%2f%2fpm1.narvii.com%2f6550%2f8992d7c1221ff853da05051b3c1ab6f9a818c882_hq.jpg&ehk=ZFjlxYoA9XM%2beiohzA2ZgUK3WdqgUDFjEsKtgzmwO2w%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Fume-shroom.',
      type: 1,
      price: 72,
      quantity: 7
    },
    {
      id: 'ETzsJVcL',
      name: 'Gatling Pea',
      image: "https://th.bing.com/th/id/OIP.mWmsTZj98o_3SJwBo7Bq2wHaJT?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Gatling Pea.',
      type: 1,
      price: 80,
      quantity: 9
    },
    {
      id: 'cgtBZELt',
      name: 'Potato Mine',
      image: "https://th.bing.com/th/id/OIP.dBHrXDT2qXbM0y0OmmdvuQHaGo?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Potato Mine.',
      type: 1,
      price: 6,
      quantity: 4
    },
    {
      id: 'DneHfjCA',
      name: 'Ice-shroom',
      image: "https://vignette.wikia.nocookie.net/pvzcc/images/a/ad/PvZ2ICESHROOM-HD.png/revision/latest?cb=20190705095937",
      description: 'This plant is from Plants vs. Zombies and it is called Ice-shroom.',
      type: 2,
      price: 44,
      quantity: 1
    },
    {
      id: 'hGrmvkSi',
      name: 'Doom-shroom',
      image: "https://th.bing.com/th/id/OIP.lUzsWWwoXUqy2XvN48ndSgHaG8?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Ice-shroom.',
      type: 1,
      price: 63,
      quantity: 1
    },
    {
      id: 'KBQDyVoQ',
      name: 'Marigold',
      image: "https://vignette.wikia.nocookie.net/plantsvszombies/images/e/eb/Marigold4.png/revision/latest/scale-to-width-down/185?cb=20120625031208",
      description: 'This plant is from Plants vs. Zombies and it is called Marigold.',
      type: 1,
      price: 89,
      quantity: 2
    },
    {
      id: 'tqpPOgmH',
      name: 'Blover',
      image: "https://th.bing.com/th/id/R.4ed505a542dbfb50ff51ed27217cfc6e?rik=axkMrSoxFH%2bTbw&riu=http%3a%2f%2fimg1.wikia.nocookie.net%2f__cb20140329160546%2fplantsvszombies%2fimages%2f4%2f43%2fBloverHD.png&ehk=J%2bkqjO5v3HKHT%2brbzIn0T3bADZ9e7ANaTslxHWphdNI%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Blover.',
      type: 2,
      price: 82,
      quantity: 8
    },
    {
      id: 'jpaiyUIW',
      name: 'Sun-shroom',
      image: "https://th.bing.com/th/id/R.9917832584bb0e64e9ed9d77f3a6a0da?rik=K6YV8VaABFLT%2fg&riu=http%3a%2f%2fimg4.wikia.nocookie.net%2f__cb20140703023013%2fplantsvszombies%2fimages%2fd%2fdf%2fHd_sun-Shroom.png&ehk=3x23z12zK%2f7vSn4GDXNPNwG%2f9OJMAkNOfHGYoW%2fZZZA%3d&risl=&pid=ImgRaw&r=0",
      description: 'This plant is from Plants vs. Zombies and it is called Sun-shroom.',
      type: 1,
      price: 11,
      quantity: 7
    },
    {
      id: 'NzUBoEVJ',
      name: 'Chomper',
      image: "https://th.bing.com/th/id/OIP.Y2_8Xni9fqvuq4Tflza54AHaIp?rs=1&pid=ImgDetMain",
      description: 'This plant is from Plants vs. Zombies and it is called Chomper.',
      type: 2,
      price: 55,
      quantity: 9
    },
    {
      id: 'sCVeoBna',
      name: 'Cattail',
      description: 'This plant is from Plants vs. Zombies and it is called Snow Pea.',
      image: "https://vignette.wikia.nocookie.net/plantsvszombies/images/5/54/Cattail2009HD.png/revision/latest?cb=20170909071533",
      type: 2,
      price: 61,
      quantity: 1
    },
    {
      id: 'AmYSsJXk',
      name: 'Melonpult',
      image: "https://vignette.wikia.nocookie.net/plantsvszombies/images/8/86/Melonpult2009HD.png/revision/latest?cb=20170909070525",
      description: 'This plant is from Plants vs. Zombies and it is called Sun-shroom.',
      type: 2,
      price: 61,
      quantity: 11
    }
  ]